/**
* 프로모션용 스크립트
*/
export default {
  data () {
    return {
      _uiClickHandler: null
    }
  },
  beforeDestroy () {
    this._removeUiEvt()
  },
  mounted () {
    this._addUiEvt()
  },
  methods: {
    // 기본 이벤트 등록
    _addUiEvt () {
      const _this = this

      // 중복 방지를 위한 기존 핸들러 제거
      if (this._uiClickHandler) {
        document.removeEventListener('click', this._uiClickHandler)
      }

      this._uiClickHandler = (e) => {
        const target = e.target
        let title, msg, url, params

        // 공유하기 버튼 클릭 이벤트
        // 이벤트 참여 동의하기 버튼 클릭 이벤트
        if (target.hasAttribute('data-share-btn')) {
          _this.$parent.share()
        }

        // 이벤트 참여 동의하기 버튼 클릭 이벤트
        if (target.hasAttribute('data-agree-btn')) {
          _this.$parent.goAgree()
        }

        // 특정 모달 팝업 호출 버튼 클릭 이벤트
        if (target.hasAttribute('data-req-class-modal')) {
          const modalTitle = target.hasAttribute('data-modal-title') ? target.getAttribute('data-modal-title') : ''
          _this.$parent.openReqClassModal(modalTitle)
        }

        // alert 팝업 이벤트
        if (target.hasAttribute('data-alert-msg')) {
          title = target.getAttribute('data-alert-msg')
          msg = target.getAttribute('data-alert-msg')
          params = {
            title: title,
            contents: msg
          }
          _this._openPopup('alert', params)
        }

        // confirm 팝업 이벤트
        if (target.hasAttribute('data-confirm-msg')) {
          title = target.getAttribute('data-confirm-title')
          msg = target.getAttribute('data-confirm-msg')
          url = target.getAttribute('data-confirm-url')
          params = {
            title: title,
            contents: msg,
            url: url
          }
          _this._openPopup('confirm', params)
        }
      }

      // 핸들러 등록
      document.addEventListener('click', this._uiClickHandler)
    },
    _removeUiEvt () {
      if (this._uiClickHandler) {
        document.removeEventListener('click', this._uiClickHandler)
        this._uiClickHandler = null
      }
    },
    // alert, confirm 팝업 열기
    _openPopup (modalType, params) {
      // alert 팝업 열기
      if (modalType === 'alert') {
        this.$popup.alert(this.$el, params)
      }

      // confirm 팝업 열기
      if (modalType === 'confirm') {
        this.$popup.confirm(this.$el, params).then((result) => {
          if (result && params.url) {
            location.href = params.url
          }
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/PromotionUi.js